import { useEffect, useState } from 'react';
import { useTemaClaroPublico } from '../lib/theme';
import { useParams } from 'react-router-dom';
import { Download } from 'lucide-react';
import { useI18n } from '../lib/i18n';
import { EffectivenessReport, type Efectividad } from '../components/EffectivenessReport';

/**
 * LA PÁGINA QUE VE EL CLIENTE — sin login, sin menú, sin nada del app.
 *
 * Vive FUERA del AppShell a propósito: quien abre este link no es un usuario del sistema y no
 * tiene por qué ver la barra lateral, el buscador ni el reloj de fichaje. Lo único que hay es el
 * reporte y un botón para bajarlo en PDF.
 *
 * Un token inválido, vencido o revocado muestran el MISMO mensaje. La página no ayuda a distinguir
 * cuál de los tres es: eso solo le serviría a alguien probando URLs.
 */
export function PublicEffectiveness() {
  // Documento para el cliente: siempre en claro, nunca el tema del staff.
  useTemaClaroPublico();
  const { t, lang } = useI18n();
  const { token } = useParams();
  const [v, setV] = useState<{ empresa: string; label: string; datos: Efectividad } | null>(null);
  const [muerto, setMuerto] = useState(false);

  useEffect(() => {
    // fetch directo y no el cliente del app: ese adjunta credenciales y redirige al login cuando
    // algo devuelve 401, y acá no hay sesión ni la tiene que haber.
    fetch(`/api/public/effectiveness/${token}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('no'))))
      .then(setV)
      .catch(() => setMuerto(true));
  }, [token]);

  if (muerto) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, background: 'var(--bg)' }}>
        <div className="card" style={{ maxWidth: 420, textAlign: 'center' }}>
          <div style={{ fontSize: 'var(--fs-lg)', fontWeight: 'var(--fw-bold)', marginBottom: 6 }}>{t('eff.goneTitle')}</div>
          <div className="muted" style={{ fontSize: 'var(--fs-sm)' }}>{t('eff.goneBody')}</div>
        </div>
      </div>
    );
  }
  if (!v) return <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: 'var(--bg)' }}><span className="muted">{t('common.loading')}</span></div>;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', padding: '32px 16px' }}>
      <div style={{ maxWidth: 860, margin: '0 auto', display: 'grid', gap: 14 }}>
        <div className="card"><EffectivenessReport d={v.datos} empresa={v.empresa} /></div>
        <div style={{ textAlign: 'center' }}>
          <a className="btn ghost sm" href={`/api/public/effectiveness/${token}/pdf?lang=${lang}`} target="_blank" rel="noreferrer">
            <Download size={13} strokeWidth={1.75} /> {t('eff.pdf')}
          </a>
        </div>
      </div>
    </div>
  );
}
